import React, { Component } from 'react'
import '../style/Footer.css';
export class Footer extends Component {
    render() {
        return (
            <div id="footer">
                <div id="socialMedia">
                    <a className="social-media-link" href="https://twitter.com/frog_ts"><i className='fab fa-twitter'></i></a>
                    <a className="social-media-link" href="https://discord.gg/pCTxnVw3By"><i className='fab fa-discord'></i></a>
                    <a className="social-media-link" href="https://t.me/nfrogts"><i className='fab fa-telegram'></i></a>
                </div>
                <span>All Rights Reserved. © 2021 nfrogts.io</span>

            </div>
        )
    }
}

export default Footer
